<template>
    <div class="page-container">
        <!-- 内容区域 -->
        <div class="content-area">
            <!-- 返回按钮 -->
            <div class="back-button-area">
                <a-button type="primary" @click="goBack">
                    <ArrowLeftOutlined />返回会议列表
                </a-button>
            </div>

            <!-- 标签页控制区域 -->
            <div class="controls-area">
                <a-segmented v-model:value="activeKey" :options="['原始记录', '语义顺滑', '会议纪要']" @change="handleTabChange" />
                
                <div class="action-buttons">
                    <div v-if="!isEditing">
                        <a-button v-if="activeKey == '会议纪要'" type="primary" @click="reloadSummary">
                            <AuditOutlined />一键总结
                        </a-button>
                        <a-button v-if="activeKey == '语义顺滑'" type="primary" @click="reloadrun">
                            <ReloadOutlined />一键修正
                        </a-button>
                        <a-button v-if="activeKey != '原始记录'" :disabled="disabledEdit" @click="handleEdit">
                            <EditOutlined />编辑
                        </a-button>
                    </div>
                    <div v-else>
                        <a-button type="primary" @click="saveMeetingRecord">
                            <SaveOutlined />保存
                        </a-button>
                        <a-button @click="handleCancelEdit">
                            <CloseCircleOutlined />取消
                        </a-button>
                    </div>
                </div>
            </div>

            <!-- 主内容区 -->
            <div class="main-content-area">
                <!-- 会议记录内容 -->
                <div class="content-box">
                    <!-- 局部加载指示器 -->
                    <div v-if="false" class="partial-loading">
                        <a-spin />
                        <div class="partial-loading-text">正在加载更多内容...</div>
                    </div>

                    <!-- 各标签页独立加载指示 -->
                    <template v-if="activeKey == '原始记录' && recordLoading">
                        <div class="tab-loading">
                            <a-spin size="large" />
                            <div class="tab-loading-text">会议内容生成中...</div>
                        </div>
                    </template>
                    <template v-else-if="activeKey == '语义顺滑' && smoothLoading">
                        <div class="tab-loading">
                            <a-spin size="large" />
                            <div class="tab-loading-text">会议内容生成中...</div>
                        </div>
                    </template>
                    <template v-else-if="activeKey == '会议纪要' && summaryLoading">
                        <div class="tab-loading">
                            <a-spin size="large" />
                            <div class="tab-loading-text">会议内容生成中...</div>
                        </div>
                    </template>
                    
                    <div v-if="!(activeKey == '原始记录' && recordLoading) && 
                             !(activeKey == '语义顺滑' && smoothLoading) && 
                             !(activeKey == '会议纪要' && summaryLoading)" 
                        v-show="activeKey == '会议纪要'" 
                        class="summary-wrap" ref="recordRef">
                        <div v-if="!isEditing" class="info-section">
                            <template v-for="item in meetingSummaryTyping" :key="item.field">
                                <div class="record-block" :class="item.vertical ? 'is-vertical' : ''">
                                    <div class="block-name">{{ item.text }}</div>
                                    <div class="block-value" style="white-space: pre-wrap;" v-html="oldMeetingSummary[item.field]">
                                    </div>
                                </div>
                            </template>
                        </div>
                        <template v-if="isEditing">
                            <template v-for="item in meetingSummaryTyping" :key="item.field">
                                <div class="record-block" :class="item.vertical ? 'is-vertical' : ''">
                                    <div class="block-name">{{ item.text }}</div>
                                    <a-textarea v-if="item.component === 'textarea'"
                                        v-model:value="editMeetingSummary[item.field]" autoSize class="textarea"></a-textarea>
                                    <a-date-picker v-else-if="item.component === 'datetimepicker'" show-time placeholder=""
                                        format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss"
                                        v-model:value="editMeetingSummary[item.field]" />
                                    <a-input v-else v-model:value="editMeetingSummary[item.field]"
                                        class="title-input"></a-input>
                                </div>
                            </template>
                        </template>
                    </div>
                    
                    <!-- 会议记录内容 -->
                    <div v-if="!(activeKey == '原始记录' && recordLoading) && 
                             !(activeKey == '语义顺滑' && smoothLoading) && 
                             !(activeKey == '会议纪要' && summaryLoading)" 
                        v-show="activeKey == '原始记录' || activeKey == '语义顺滑'" 
                        class="record-wrap" ref="recordRef">
                        <!-- 信息区 -->
                        <div v-show="!isEditing" class="info-section">
                            <template v-for="item in meetingRecordTyping" :key="item.field">
                                <div class="record-block" :class="item.vertical ? 'is-vertical' : ''">
                                    <div class="block-name">{{ item.text }}</div>
                                    <div class="block-value">{{ currentMeetingData[item.field] }}</div>
                                </div>
                            </template>
                        </div>
                        
                        <!-- 编辑区 -->
                        <div v-show="isEditing" class="info-section">
                            <template v-for="item in meetingRecordTyping" :key="item.field">
                                <div class="record-block" :class="item.vertical ? 'is-vertical' : ''">
                                    <div class="block-name">{{ item.text }}</div>
                                    <a-textarea v-if="item.component === 'textarea'" v-model:value="editMeeting[item.field]"
                                        autoSize class="textarea"></a-textarea>
                                    <a-date-picker v-else-if="item.component === 'datetimepicker'" show-time placeholder=""
                                        format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss"
                                        v-model:value="editMeeting[item.field]" />
                                    <a-select v-else-if="item.component === 'select'" v-model:value="editMeeting[item.field]"
                                        :options="state.data" allowClear showSearch style="width: 100%" mode="tags">
                                    </a-select>
                                    <a-input v-else v-model:value="editMeeting[item.field]" class="title-input"></a-input>
                                </div>
                            </template>
                        </div>
                        
                        <!-- 内容区 -->
                        <div class="content-section">
                            <h2 class="content-label">会议内容：</h2>
                            <div v-if="!isEditing" class="mt-record-content" ref="recordContent">
                                <div v-for="(item, index) in currentMeetingData.records" :key="index" class="record-item">
                                    <div class="mt-record-header">
                                        <span class="speaker">{{ item.speaker }}</span>
                                        <span class="time">{{ item.time }}</span>
                                    </div>
                                    <div class="content" :class="item.isplaying ? 'is-playing' : ''" v-html="item.rawContent"
                                        @click="goContent(index)">
                                    </div>
                                </div>
                                
                                <!-- 底部loading指示器（非编辑模式） -->
                                <div v-if="bottomLoading" class="bottom-loading">
                                    <a-spin size="small" />
                                    <span class="bottom-loading-text">正在加载更多数据...</span>
                                </div>
                            </div>
                            <div v-else class="mt-record-content" ref="recordContent">
                                <div v-for="(item, index) in meetingRecord" :key="index" class="record-item"
                                    :class="item.is_delete ? 'is-delete' : ''">
                                    <div class="mt-record-header">
                                        <a-select class="speaker" v-model:value="item.speaker" style="width: 160px"
                                            :options="editMeeting.speaker_list.map(option => ({ label: option, value: option }))"
                                            @change="speakerChange($event, item.id)">
                                        </a-select>
                                        <a-time-picker placeholder="" format="HH:mm:ss" valueFormat="HH:mm:ss" :showNow="false"
                                            v-model:value="item.full_time" />
                                        <a-button
                                            v-if="splitParams.recordIndex == index && splitParams.startContent && splitParams.endContent"
                                            type="primary" class="im-btn" danger size="small"
                                            @click="handleSplit(index)">拆分</a-button>
                                        <a-button v-if="splitParams.recordIndex == index" type="primary" class="im-btn" danger
                                            size="small" @click="handleDelete(index)">删除</a-button>
                                        <a-button v-if="splitParams.recordIndex == index && selectContent" type="primary"
                                            class="im-btn" size="small" @click="handleKeynote(index, item.text)">重点</a-button>
                                        <a-button v-if="splitParams.recordIndex == index && selectContent" type="primary"
                                            class="im-btn" danger size="small" @click="handleTodo(index, item.text)">待办</a-button>
                                        <a-button v-if="splitParams.recordIndex == index && selectContent" type="primary" danger
                                            size="small" @click="handleCancelNote(index, item.text)">取消</a-button>
                                    </div>
                                    <div class="content editing-content" :class="item.isplaying ? 'is-playing' : ''"
                                        v-html="item.text" contenteditable="true" :data-content="item.text"
                                        @click="goContent(index)">
                                    </div>
                                </div>
                                
                                <!-- 底部loading指示器（编辑模式） -->
                                <div v-if="bottomLoading" class="bottom-loading">
                                    <a-spin size="small" />
                                    <span class="bottom-loading-text">正在加载更多数据...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- 音频播放区 -->
            <div class="audio-player-container">
                <HszdAudio ref="audioRef" :source="audio_url" @time="audioTimeChange" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { Modal, message } from 'ant-design-vue';
import { reactive, ref, onActivated, nextTick, h, onMounted, watch, createVNode, onUnmounted, computed, onDeactivated } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router'
import HszdAudio from '@/components/hszdAudio/HszdAudio.vue';
import {
    SaveOutlined,
    CloseCircleOutlined,
    EditOutlined,
    ReloadOutlined,
    ExclamationCircleOutlined,
    AuditOutlined,
    ArrowLeftOutlined
} from '@ant-design/icons-vue';
import { BASE_URL } from '@/config/api';
import { rawText, filteredContent, formattedContent, convertTimeToSeconds } from '@/utils/utils'

const recordRef = ref();
// 各标签页独立的加载状态
const recordLoading = ref(true);
const smoothLoading = ref(true);
const summaryLoading = ref(true);
// 将局部加载状态改为计算属性，始终返回false，这样就不会显示局部loading
const partialLoading = computed(() => false); // 局部加载状态
// 底部loading状态，当有数据但轮询未结束时显示
const bottomLoading = ref(true);
const router = useRouter()
const activeKey = ref('原始记录')
const audioRef = ref()
const state = reactive({
    data: [],
    value: [],
    fetching: false,
});
const recordContent = ref()
const myPermission = computed(() => {
    const permission = localStorage.getItem('myPermission') || '{}'
    return JSON.parse(permission)
})

// 添加一个响应式引用来存储定时器ID
const checkStatusTimer = ref(null);
// 添加一个响应式引用来存储状态检查定时器
const stateCheckTimer = ref(null);
// 添加WebSocket检查定时器ID
const wsCheckIntervalId = ref(null);

// 简化模态框显示
const showPropsConfirm = () => {
    // 创建进度值的响应式引用
    const progressPercent = ref(0);
    // 目标进度值 - 后端返回的真实进度
    const targetProgress = ref(0);
    // 上次检查时间
    const lastCheckTime = ref(Date.now());
    // 上次动画更新时间
    const lastAnimationTime = ref(Date.now());
    // 状态描述文本
    const statusText = ref('正在准备模型资源...');
    
    // 根据进度更新状态文本
    const updateStatusText = (progress) => {
        if (progress < 20) {
            statusText.value = '正在准备模型资源...';
        } else if (progress < 40) {
            statusText.value = '正在分析音频内容...';
        } else if (progress < 60) {
            statusText.value = '正在生成原始记录...';
        } else if (progress < 80) {
            statusText.value = '正在进行语义顺滑...';
        } else {
            statusText.value = '正在生成会议总结...';
        }
    };
    
    // 进度增长策略
    const getProgressIncrement = (currentProgress) => {
        // 经过的时间（秒）
        const elapsedTime = (Date.now() - lastCheckTime.value) / 1000;
        lastCheckTime.value = Date.now();
        
        // 基础增长速度，随时间动态调整
        // 开始快一些，接近完成时慢一些
        let baseIncrement;
        
        if (currentProgress < 30) {
            // 开始阶段增长快一些
            baseIncrement = 1.2 * elapsedTime;
        } else if (currentProgress < 60) {
            // 中间阶段适中
            baseIncrement = 0.8 * elapsedTime;
        } else if (currentProgress < 80) {
            // 接近结束阶段放慢
            baseIncrement = 0.5 * elapsedTime;
        } else {
            // 最后阶段很慢
            baseIncrement = 0.3 * elapsedTime;
        }
        
        // 添加一些随机性 (±20%)
        const randomFactor = 0.8 + Math.random() * 0.4;
        
        // 计算最终增量，确保至少有一点增长
        return Math.max(0.2, baseIncrement * randomFactor);
    };
    
    // 平滑过渡到目标进度
    const smoothToTargetProgress = () => {
        // 如果已经到达100%或进度条已关闭，停止动画
        if (progressPercent.value >= 100 || !checkStatusTimer.value) return;
        
        const now = Date.now();
        const dt = (now - lastAnimationTime.value) / 1000; // 秒
        lastAnimationTime.value = now;
        
        // 当前进度与目标之间的差距
        const diff = targetProgress.value - progressPercent.value;
        
        if (Math.abs(diff) < 0.1) {
            // 如果差距很小，直接赋值
            progressPercent.value = targetProgress.value;
        } else {
            // 动态计算步长，差距越大，步长越大
            let step = diff * dt * 2.0; // 基础系数
            
            // 限制每次最大步长，防止跳变太快
            if (diff > 0) {
                step = Math.min(step, diff * 0.2); // 每次最多移动差距的20%
                step = Math.min(step, 5); // 每次最多移动5%
            } else {
                step = Math.max(step, diff * 0.2);
                step = Math.max(step, -5);
            }
            
            // 应用步长，更新进度
            progressPercent.value += step;
        }
        
        // 更新状态文本
        updateStatusText(progressPercent.value);
        
        // 更新进度条显示
        modalIns.update({
            content: renderProgressContent()
        });
        
        // 请求下一帧动画
        requestAnimationFrame(smoothToTargetProgress);
    };
    
    // 创建进度条内容
    const renderProgressContent = () => {
        return h('div', { style: 'width: 100%' }, [
            h('div', { 
                style: 'margin-bottom: 16px; text-align: center; font-weight: 500;'
            }, statusText.value),
            h('a-progress', { 
                percent: Number(progressPercent.value.toFixed(1)), 
                status: 'active',
                strokeColor: {
                    '0%': '#108ee9',
                    '100%': '#87d068'
                },
                strokeWidth: 8
            }),
            h('div', { 
                style: 'margin-top: 12px; text-align: center; color: #666; font-size: 13px;'
            }, `已完成: ${progressPercent.value.toFixed(1)}%`),
            h('div', {
                style: 'margin-top: 8px; text-align: center; color: #888; font-size: 12px;'
            }, '请耐心等待，处理时间取决于会议内容长度')
        ]);
    };
    
    const modalIns = Modal.info({
        title: '处理进度',
        content: renderProgressContent(),
        footer: null,
        maskClosable: false,
        width: 420
    });

    if (checkStatusTimer.value) {
        clearInterval(checkStatusTimer.value);
    }
    
    // 启动平滑过渡动画
    requestAnimationFrame(smoothToTargetProgress);

    checkStatusTimer.value = setInterval(() => {
        // 构建包含当前进度的URL
        const apiUrl = `${BASE_URL}/check_meeting_record_and_summary/${router.currentRoute.value.params.id}?current_progress=${progressPercent.value.toFixed(1)}`;
        
        fetch(apiUrl)
            .then(response => response.json())
            .then(body => {
                if (typeof body === 'object' && body.progress !== undefined) {
                    // 如果后端返回的是带进度的对象
                    targetProgress.value = body.progress;
                    
                    // 当进度达到100%时，清理并获取最新数据
                    if (body.progress >= 100) {
                        // 快速过渡到100%
                        progressPercent.value = 100;
                        modalIns.update({
                            content: renderProgressContent()
                        });
                        
                        // 延迟关闭，给用户看到100%的视觉反馈
                        setTimeout(() => {
                            clearInterval(checkStatusTimer.value);
                            checkStatusTimer.value = null;
                            modalIns.destroy();
                            
                            // 重置缓存数据，确保下次获取时能更新视图
                            prevMeetingSummary.value = null;
                            prevMeetingRecords.value = null;
                            prevSmoothTextRecords.value = null;
                            
                            // 显示局部loading
                            partialLoading.value = true;
                            
                            // 获取最新数据
                            Promise.all([
                                get_meeting_summary(),
                                get_meeting_record(),
                                get_smooth_text_record()
                            ]).then(() => {
                                // 重新检查会议状态，确保轮询继续工作
                                get_meeting_state().then(data => {
                                    if (data && 
                                        (data.audio_record_status !== 2 || 
                                         data.meeting_status !== 2 || 
                                         data.audio_summit_status !== 2)) {
                                        // 如果会议仍在处理中，确保轮询继续
                                        console.log(`进度完成后检查状态: audio_record_status=${data.audio_record_status}, meeting_status=${data.meeting_status}, audio_summit_status=${data.audio_summit_status}`);
                                        ensurePollingActive();
                                    }
                                });
                                partialLoading.value = false; // 完成局部加载
                            }).catch(() => {
                                partialLoading.value = false;
                            });
                        }, 500);
                    }
                } else if (body === true) {
                    // 兼容旧接口，如果返回true表示处理完成
                    // 快速过渡到100%
                    targetProgress.value = 100;
                    progressPercent.value = 100;
                    modalIns.update({
                        content: renderProgressContent()
                    });
                    
                    // 延迟关闭，给用户看到100%的视觉反馈
                    setTimeout(() => {
                        clearInterval(checkStatusTimer.value);
                        checkStatusTimer.value = null;
                        modalIns.destroy();
                        
                        // 重置缓存数据，确保下次获取时能更新视图
                        prevMeetingSummary.value = null;
                        prevMeetingRecords.value = null;
                        prevSmoothTextRecords.value = null;
                        
                        // 显示局部loading
                        partialLoading.value = true;
                        
                        // 获取最新数据
                        Promise.all([
                            get_meeting_summary(),
                            get_meeting_record(),
                            get_smooth_text_record()
                        ]).then(() => {
                            // 重新检查会议状态，确保轮询继续工作
                            get_meeting_state().then(data => {
                                if (data && 
                                    (data.audio_record_status !== 2 || 
                                     data.meeting_status !== 2 || 
                                     data.audio_summit_status !== 2)) {
                                    // 如果会议仍在处理中，确保轮询继续
                                    console.log(`进度完成后检查状态: audio_record_status=${data.audio_record_status}, meeting_status=${data.meeting_status}, audio_summit_status=${data.audio_summit_status}`);
                                    ensurePollingActive();
                                }
                            });
                            partialLoading.value = false;
                        }).catch(() => {
                            partialLoading.value = false;
                        });
                    }, 500);
                } else {
                    // 如果没有进度信息，使用自然增长的进度
                    const increment = getProgressIncrement(targetProgress.value);
                    // 确保不超过95%
                    targetProgress.value = Math.min(95, targetProgress.value + increment);
                }
            }).catch(() => { 
                // 出错时也增加一点进度以给用户反馈
                const increment = getProgressIncrement(targetProgress.value) * 0.5; // 错误时进度增长较慢
                targetProgress.value = Math.min(95, targetProgress.value + increment);
            });
    }, 2000); // 恢复到2秒的检查间隔，因为有动画平滑过渡
};

// 添加深度比较函数，用于比较两个对象是否相等
const deepEqual = (obj1, obj2) => {
  if (obj1 === obj2) return true;
  
  if (obj1 == null || obj2 == null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false;
  }
  
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  
  if (keys1.length !== keys2.length) return false;
  
  for (const key of keys1) {
    if (!Object.prototype.hasOwnProperty.call(obj2, key)) {
      return false;
    }
    
    if (!deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }
  
  return true;
};

// 缓存上次数据的引用
const prevMeetingState = ref(null);
const prevMeetingSummary = ref(null);
const prevMeetingRecords = ref(null);
const prevSmoothTextRecords = ref(null);

const isEditing = ref(false)
const audio_url = ref()


const MAIN_SYMBLE = '%t'
const HARD_SYMBLE = '%h'

// 拆分文本
const splitParams = reactive({
    startContent: '',
    endContent: '',
    recordIndex: -1
})
// 选中的文本
const selectContent = ref()
const selectPosition = ref(0)
const appEventListener = ref()
const textListenerList = {
    mousedownEvent: [],
    mouseupEvent: [],
    inputEvent: []
}
const subscribeSplitEvent = () => {
    const domList = recordContent.value?.querySelectorAll('.editing-content')
    if (domList) {

        domList.forEach((item, index) => {
            const mousedownEvent = function () {
                // console.log('当前鼠标mousedown的段落index', index)
                splitParams.recordIndex = index
                const selection = window.getSelection();
                // 获取光标位置
                const editContent = item.textContent
                setTimeout(() => {
                    const parentNode = selection.anchorNode.parentNode
                    const isMain = parentNode.className == 'main-highlight'
                    const isHard = parentNode.className == 'todo-highlight'
                    const oIndex = editContent.indexOf(selection.anchorNode.nodeValue)

                    const cursorPosition = oIndex + selection.anchorOffset
                    // 获取光标前的文本
                    let textBeforeCursor = editContent.substring(0, cursorPosition)
                    // 获取光标后的文本
                    let textAfterCursor = editContent.substring(cursorPosition)
                    if (textBeforeCursor && textAfterCursor) {
                        // 如果分割的是特殊文字，需要收尾拼接特定符号
                        if (isMain) {
                            textBeforeCursor = textBeforeCursor + MAIN_SYMBLE
                            textAfterCursor = MAIN_SYMBLE + textAfterCursor
                        }
                        if (isHard) {
                            textBeforeCursor = textBeforeCursor + HARD_SYMBLE
                            textAfterCursor = HARD_SYMBLE + textAfterCursor
                        }
                        splitParams.startContent = textBeforeCursor
                        splitParams.endContent = textAfterCursor

                    } else {
                        splitParams.startContent = ''
                        splitParams.endContent = ''
                    }
                }, 0)
            }

            const mouseupEvent = function () {
                splitParams.recordIndex = index
                const selection = window.getSelection();
                // const editContent = item.innerText
                const editContent = filteredContent(item.innerHTML)
                // 获取选中文本的起始和结束位置
                setTimeout(() => {
                    let anchorIndex = editContent.indexOf(selection.anchorNode.nodeValue)
                    const focusIndex = editContent.indexOf(selection.focusNode.nodeValue)

                    let cursorPositionStart = anchorIndex + selection.anchorOffset
                    let cursorPositionEnd = focusIndex + selection.focusOffset
                    // 如果不相等，则说明选中的是 重点或待办的字符
                    if (item.innerHTML != selection.baseNode.parentElement.innerHTML) {

                        if (selection.baseNode.parentElement.className.includes('todo-highlight')) {
                            anchorIndex = editContent.indexOf(HARD_SYMBLE + selection.baseNode.parentElement.innerHTML + HARD_SYMBLE)
                        }
                        if (selection.baseNode.parentElement.className.includes('main-highlight')) {
                            anchorIndex = editContent.indexOf(MAIN_SYMBLE + selection.baseNode.parentElement.innerHTML + MAIN_SYMBLE)
                        }

                        cursorPositionStart = anchorIndex + 2 + selection.anchorOffset
                    }
                    // 检查是否有文本被选中
                    if (cursorPositionStart !== cursorPositionEnd) {
                        // 如果是从后向前选，则交换两个值
                        if (cursorPositionStart > cursorPositionEnd) {
                            [cursorPositionStart, cursorPositionEnd] = [cursorPositionEnd, cursorPositionStart]
                        }
                        selectPosition.value = cursorPositionStart < cursorPositionEnd ? cursorPositionStart : cursorPositionEnd

                        const tmp = editContent.substring(cursorPositionStart, cursorPositionEnd)
                        selectContent.value = tmp
                        if (cursorPositionStart > 0) {
                            const prevWord = editContent.substring(cursorPositionStart - 2, cursorPositionStart)
                            if (prevWord == MAIN_SYMBLE || prevWord == HARD_SYMBLE) {
                                selectContent.value = prevWord + selectContent.value
                                selectPosition.value = selectPosition.value - 2
                            }
                        }
                        if (cursorPositionEnd < editContent.length) {
                            const nextWord = editContent.substring(cursorPositionEnd, cursorPositionEnd + 2)
                            if (nextWord == MAIN_SYMBLE || nextWord == HARD_SYMBLE) {
                                selectContent.value = selectContent.value + nextWord

                            }
                        }
                    }
                }, 0)

            }

            const inputEvent = function () {
                const selection = window.getSelection();
                // 获取光标位置
                const editContent = item.textContent
                setTimeout(() => {
                    const parentNode = selection.anchorNode.parentNode
                    const isMain = parentNode.className == 'main-highlight'
                    const isHard = parentNode.className == 'todo-highlight'
                    const oIndex = editContent.indexOf(selection.anchorNode.nodeValue)

                    const cursorPosition = oIndex + selection.anchorOffset
                    // 获取光标前的文本
                    let textBeforeCursor = editContent.substring(0, cursorPosition)
                    // 获取光标后的文本
                    let textAfterCursor = editContent.substring(cursorPosition)
                    if (textBeforeCursor && textAfterCursor) {
                        // 如果分割的是特殊文字，需要收尾拼接特定符号
                        if (isMain) {
                            textBeforeCursor = textBeforeCursor + MAIN_SYMBLE
                            textAfterCursor = MAIN_SYMBLE + textAfterCursor
                        }
                        if (isHard) {
                            textBeforeCursor = textBeforeCursor + HARD_SYMBLE
                            textAfterCursor = HARD_SYMBLE + textAfterCursor
                        }
                        splitParams.startContent = textBeforeCursor
                        splitParams.endContent = textAfterCursor

                    } else {
                        splitParams.startContent = ''
                        splitParams.endContent = ''
                    }
                }, 0)
            }
            item.addEventListener('mousedown', mousedownEvent)

            item.addEventListener('mouseup', mouseupEvent)

            item.addEventListener('input', inputEvent)

            textListenerList.mousedownEvent.push(mousedownEvent)
            textListenerList.mouseupEvent.push(mouseupEvent)
            textListenerList.inputEvent.push(inputEvent)
        })
    }
}
const cancelSubscribeSplitEvent = () => {
    textListenerList.mousedownEvent.forEach(event => {
        window.removeEventListener('mousedown', event)
    })
    textListenerList.mouseupEvent.forEach(event => {
        window.removeEventListener('mouseup', event)
    })
    textListenerList.inputEvent.forEach(event => {
        window.removeEventListener('input', event)
    })
}
onMounted(() => {
    appEventListener.value = (event) => {
        const innerText = event.target.innerText?.replace(/\s+/g, '')
        if (!event.target.className?.includes?.('editing-content') && innerText != '拆分'
            && innerText != '删除' && innerText != '重点' && innerText != '待办' && innerText != '取消') {
            splitParams.recordIndex = -1
        }
        if (innerText == '重点' || innerText == '待办' || innerText == '取消') return
        selectContent.value = null
    }
    window.addEventListener('mousedown', appEventListener.value)
    
    // 阻止WebSocket连接
    const closeAnyExistingWebsocket = () => {
        // 检查全局是否有WebSocket连接尝试
        if (window.ws && typeof window.ws.close === 'function') {
            console.log('编辑页面检测到WebSocket连接，已关闭');
            window.ws.close();
            window.ws = null;
        }
        
        // 检查是否有正在尝试连接的WebSocket
        const originalWebSocket = window.WebSocket;
        // 保存原始WebSocket构造函数以便后续恢复
        if (!window._originalWebSocket) {
            window._originalWebSocket = originalWebSocket;
        }
        
        window.WebSocket = function(url, ...args) {
            if (url.includes('ws://localhost:8081/ws') || url.includes('wss://api.halloai.tech:8800/ws')) {
                console.info('编辑页面阻止WebSocket连接:', url);
                // 返回一个模拟的WebSocket对象，但不真正连接
                return {
                    readyState: 3, // CLOSED状态
                    send: () => {},
                    close: () => {},
                    addEventListener: () => {},
                    removeEventListener: () => {}
                };
            }
            return new originalWebSocket(url, ...args);
        };
    };
    
    // 立即执行一次
    closeAnyExistingWebsocket();
    
    // 每隔几秒检查一次，确保不会有新连接
    wsCheckIntervalId.value = setInterval(closeAnyExistingWebsocket, 2000);
})

onUnmounted(() => {
    console.log('组件卸载，清理资源和缓存');
    
    window.removeEventListener('mousedown', appEventListener.value)
    cancelSubscribeSplitEvent()
    
    // 清空缓存数据
    clearCacheData();
    
    // 在组件卸载时清理定时器
    if (checkStatusTimer.value) {
        clearInterval(checkStatusTimer.value)
        checkStatusTimer.value = null
    }
    
    // 清理状态检查定时器
    if (stateCheckTimer.value) {
        clearInterval(stateCheckTimer.value)
        stateCheckTimer.value = null
    }
    
    // 清理WebSocket检查定时器
    if (wsCheckIntervalId.value) {
        clearInterval(wsCheckIntervalId.value);
        wsCheckIntervalId.value = null;
    }
    
    // 清理所有可能存在的其他定时器
    const intervalIds = window.intervalIds || [];
    intervalIds.forEach(id => clearInterval(id));
    
    // 恢复原始WebSocket构造函数
    if (window._originalWebSocket) {
        window.WebSocket = window._originalWebSocket;
    }
    
    // 记录组件已卸载
    console.log('MettingEdit组件已卸载，所有定时器已清理');
})

// 添加onDeactivated钩子，在组件失活时（如路由切换）清理定时器
onDeactivated(() => {
    console.log('组件失活，清理定时器和缓存');
    
    // 清空缓存数据，防止下次进入时显示之前的会议数据
    clearCacheData();
    
    // 在组件失活时清理定时器
    if (checkStatusTimer.value) {
        clearInterval(checkStatusTimer.value)
        checkStatusTimer.value = null
    }
    
    // 清理状态检查定时器
    if (stateCheckTimer.value) {
        clearInterval(stateCheckTimer.value)
        stateCheckTimer.value = null
    }
    
    // 清理WebSocket检查定时器
    if (wsCheckIntervalId.value) {
        clearInterval(wsCheckIntervalId.value);
        wsCheckIntervalId.value = null;
    }
    
    // 恢复原始WebSocket构造函数
    if (window._originalWebSocket) {
        window.WebSocket = window._originalWebSocket;
    }
    
    console.log('MettingEdit组件已失活，所有定时器已清理');
})
const goContent = (index) => {
    if (isEditing.value) {
        const time = meetingRecord.value[index].time
        audioRef.value.setPlayTime(convertTimeToSeconds(time))
    } else {
        const time = oldMeeting.records[index].time
        audioRef.value.setPlayTime(convertTimeToSeconds(time))
    }
}
// 修改段落说话人
const speakerChange = (value, id) => {
    const editItem = oldMeeting.records.find(item => item.id == id)
    const editIndex = oldMeeting.records.findIndex(item => item.id == id)
    meetingRecord.value[editIndex].is_match = true
    // 其他段落和当前段落的说话人一样时，同时修改
    meetingRecord.value.forEach(item => {
        if (item.speaker == editItem.speaker && item.id > id) {
            item.speaker = value
            if (!item.is_match) {
                item.is_match = true
            }
        }
    })
}
// 拆分
const handleSplit = (index) => {
    if (splitParams.startContent && splitParams.endContent) {
        meetingRecord.value[index] = {
            ...meetingRecord.value[index],
            text: formattedContent(splitParams.startContent, MAIN_SYMBLE, HARD_SYMBLE),
        }
        meetingRecord.value.splice(index + 1, 0, {
            ...meetingRecord.value[index],
            isSplit: true,
            text: formattedContent(splitParams.endContent, MAIN_SYMBLE, HARD_SYMBLE),
        })
        splitParams.recordIndex = -1
    }
    cancelSubscribeSplitEvent()
    nextTick(() => {
        subscribeSplitEvent()
    })

}
// 删除
const handleDelete = (index) => {
    Modal.confirm({
        title: '删除确认',
        content: '确认删除吗？',
        icon: createVNode(ExclamationCircleOutlined),
        okText: '确认',
        cancelText: '取消',
        onOk() {
            meetingRecord.value[index].is_delete = true
        },
    });
}

// 重点
const handleKeynote = (index, text) => {
    // console.log('开始标记重点')
    const oldContent = filteredContent(text)
    let prevContent = oldContent.substring(0, selectPosition.value)
    let nextContent = oldContent.substring(selectPosition.value + selectContent.value.length)
    const prevFlagLength = prevContent.match(new RegExp(HARD_SYMBLE, 'g'))?.length || 0
    const nextFlagLength = nextContent.match(new RegExp(HARD_SYMBLE, 'g'))?.length || 0
    if (prevFlagLength % 2 == 1 || nextFlagLength % 2 == 1) {
        message.info('当前本文为待办，不能标记为重点');
        return
    }
    handleFlag(index, text, MAIN_SYMBLE)
}

// 待办
const handleTodo = (index, text) => {
    const oldContent = filteredContent(text)
    let prevContent = oldContent.substring(0, selectPosition.value)
    let nextContent = oldContent.substring(selectPosition.value + selectContent.value.length)
    const prevFlagLength = prevContent.match(new RegExp(MAIN_SYMBLE, 'g'))?.length || 0
    const nextFlagLength = nextContent.match(new RegExp(MAIN_SYMBLE, 'g'))?.length || 0
    if (prevFlagLength % 2 == 1 || nextFlagLength % 2 == 1) {
        message.info('当前本文为重点，不能标记为待办');
        return
    }
    handleFlag(index, text, HARD_SYMBLE)
}

// 取消 重点/待办
const handleCancelNote = (index, text) => {
    const oldContent = filteredContent(text)
    let replaceContent = rawText(selectContent.value, MAIN_SYMBLE, HARD_SYMBLE)
    let prevContent = oldContent.substring(0, selectPosition.value)
    let nextContent = oldContent.substring(selectPosition.value + selectContent.value.length)
    const main_simple_reg = new RegExp(MAIN_SYMBLE, 'g')
    const hard_simple_reg = new RegExp(HARD_SYMBLE, 'g')
    // 重点
    const prevMainFlagLength = prevContent.match(main_simple_reg)?.length || 0
    const nextMainFlagLength = nextContent.match(main_simple_reg)?.length || 0
    const prevHardFlagLength = prevContent.match(hard_simple_reg)?.length || 0
    const nextHardFlagLength = nextContent.match(hard_simple_reg)?.length || 0
    // 选中的文本处于中【重点】文本之间
    if (prevMainFlagLength % 2 == 1) {
        prevContent = prevContent + MAIN_SYMBLE
    }
    if (prevHardFlagLength % 2 == 1) {
        prevContent = prevContent + HARD_SYMBLE
    }
    if (nextMainFlagLength % 2 == 1) {
        nextContent = MAIN_SYMBLE + nextContent
    }
    if (nextHardFlagLength % 2 == 1) {
        nextContent = HARD_SYMBLE + nextContent
    }
    const newContent = prevContent + replaceContent + nextContent

    meetingRecord.value[index].text = formattedContent(newContent, MAIN_SYMBLE, HARD_SYMBLE)
    selectContent.value = ''
}
// 重点 / 待办
const handleFlag = (index, text, flag) => {
    const oldContent = filteredContent(text)
    let replaceContent = rawText(selectContent.value, MAIN_SYMBLE, HARD_SYMBLE)
    let prevContent = oldContent.substring(0, selectPosition.value)
    let nextContent = oldContent.substring(selectPosition.value + selectContent.value.length)
    const totalFlagLength = oldContent.match(new RegExp(flag, 'g'))?.length || 0
    const prevFlagLength = prevContent.match(new RegExp(flag, 'g'))?.length || 0
    const nextFlagLength = nextContent.match(new RegExp(flag, 'g'))?.length || 0

    // 选中的字符 处于 重点或者待办文本之间
    if (prevFlagLength % 2 == 1 && nextFlagLength % 2 == 1 && (prevFlagLength + nextFlagLength) == totalFlagLength) {
        return
    }
    // 选中的字符 处于 多段重点/待办文本之间
    if (prevFlagLength % 2 == 1 && nextFlagLength % 2 == 1) {
        const lastIndex = prevContent.lastIndexOf(flag);
        const prevIndex = nextContent.indexOf(flag);
        replaceContent = prevContent.substring(lastIndex + 2) + replaceContent + nextContent.substring(0, prevIndex)
        prevContent = prevContent.substring(0, lastIndex)
        nextContent = nextContent.substring(prevIndex + 2)
    }
    if (prevFlagLength % 2 == 1 && nextFlagLength % 2 == 0) {
        const lastIndex = prevContent.lastIndexOf(flag);
        replaceContent = prevContent.substring(lastIndex + 2) + replaceContent
        prevContent = prevContent.substring(0, lastIndex)
    }
    if (prevFlagLength % 2 == 0 && nextFlagLength % 2 == 1) {
        const prevIndex = nextContent.indexOf(flag);
        replaceContent = replaceContent + nextContent.substring(0, prevIndex)
        nextContent = nextContent.substring(prevIndex + 2)
    }
    replaceContent = flag + replaceContent + flag
    const newContent = prevContent + replaceContent + nextContent
    meetingRecord.value[index].text = formattedContent(newContent, MAIN_SYMBLE, HARD_SYMBLE)
    selectContent.value = ''
}
// 原始记录标头字段
const meetingRecordTyping = [
    {
        text: '会议名称：',
        field: 'title'
    },
    {
        text: '会议时间：',
        field: 'create_time',
        component: 'datetimepicker'
    },
    {
        text: '参会人员：',
        field: 'speaker_list',
        component: 'select'
    },
]
const oldMeetingSummary = reactive({
})
const editMeetingSummary = reactive({
})

// 监听摘要数据变化，自动关闭对应loading
watch(
    () => Object.values(oldMeetingSummary).some(v => v !== undefined && v !== null && v !== ''),
    (hasData) => {
        if (hasData) summaryLoading.value = false
    }
)

// 会议总结字段
const meetingSummaryTyping = [
    {
        text: '会议名称：',
        field: 'meeting_name'
    },
    {
        text: '会议时间：',
        field: 'meeting_date',
        component: 'datetimepicker'
    },
    {
        text: '会议主题：',
        field: 'meeting_title'
    },
    {
        text: '会议关键词：',
        field: 'meeting_words',
    },
    {
        text: '参会人员：',
        field: 'users',
    },
    {
        text: '会议重点：',
        field: 'meeting_content',
        vertical: true,
        component: 'textarea'
    },
    {
        text: '会议计划：',
        field: 'meeting_plan',
        vertical: true,
        component: 'textarea'
    }
]

// 一键总结
/* eslint-disable */
const reloadSummary = () => {

    // 如果状态异常着弹窗提示
    if (disabledEdit.value) {
        // 确认框提示
        Modal.confirm({
            title: '当前总结运行中,确认重新运行一键总结？',
            icon: createVNode(ExclamationCircleOutlined),
            okText: '确认',
            cancelText: '取消',
            onOk() {
                showPropsConfirm()
                axios.post(`${BASE_URL}/reload_summary/${router.currentRoute.value.params.id}`)
                    .then(response => response.json())
                    .then(body => {
                        console.log('body', body)
                    }).catch(() => { });
            },
            onCancel() {

            }
        });
    } else {
        showPropsConfirm()
        axios.post(`${BASE_URL}/reload_summary/${router.currentRoute.value.params.id}`)
            .then(response => response.json())
            .then(body => {
                console.log('body', body)
            }).catch(() => { });
    }
}

// 重新获取整体识别记录
const reloadrun = () => {
    // 如果状态异常着弹窗提示
    if (disabledEdit.value) {
        // 确认框提示
        Modal.confirm({
            title: '当前总结运行中,确认重新运行一键修正？',
            icon: createVNode(ExclamationCircleOutlined),
            okText: '确认',
            cancelText: '取消',
            onOk() {
                // 弹窗显示loading
                showPropsConfirm()
                const endpoint = activeKey.value === '原始记录' ? 'reload_all' : 'reload_all';
                fetch(`${BASE_URL}/${endpoint}/${router.currentRoute.value.params.id}`)
                    .then(response => response.json())
                    .then(body => {
                        console.log('body', body)
                    }).catch(() => { });
            },
            onCancel() {

            }
        });
    } else {
        // 弹窗显示loading
        showPropsConfirm()
        const endpoint = activeKey.value === '原始记录' ? 'reload_all' : 'reload_all';
        fetch(`${BASE_URL}/${endpoint}/${router.currentRoute.value.params.id}`)
            .then(response => response.json())
            .then(body => {
                console.log('body', body)
            }).catch(() => { });
    }
}

// 取消编辑
const handleCancelEdit = () => {
    meetingRecord.value = meetingRecord.value.filter(item => !item.isSplit)
    isEditing.value = false
    splitParams.recordIndex = -1
}

// Add new reactive state for smooth text records
const oldSmoothText = reactive({
    records: []
});

// 监听平滑文本数据变化，自动关闭对应loading
watch(
    () => oldSmoothText.records.length,
    (len) => {
        if (len > 0) smoothLoading.value = false
    }
)

// Add a computed property to determine which data to show
const currentMeetingData = computed(() => {
    if (activeKey.value === '原始记录') {
        return oldMeeting;
    }
    return {
        title: oldMeeting.title,
        create_time: oldMeeting.create_time,
        speaker_list: oldMeeting.speaker_list,
        records: oldSmoothText.records && oldSmoothText.records.length > 0 ? oldSmoothText.records : oldMeeting.records
    };
});

// 获取原始记录 
const get_meeting_record = async () => {
    try {
        // 只有在显式调用时才设置局部loading，轮询时不重复设置
        if (!partialLoading.value) {
            partialLoading.value = true; // 开始局部加载
        }
        
        const response = await fetch(`${BASE_URL}/meetingrecord/${router.currentRoute.value.params.id}`);
        const data = await response.json();
        
        // 检查是否有实际数据
        const hasActualData = Array.isArray(data) && data.length > 0;
        console.log(`获取会议记录: ${hasActualData ? '有数据' : '无数据'}, 数据长度: ${Array.isArray(data) ? data.length : 0}`);
        
        // 如果是首次加载或数据总条数增加，则使用增量加载
        const isFirstLoad = !prevMeetingRecords.value;
        const hasMoreData = prevMeetingRecords.value && data.length > prevMeetingRecords.value.length;
        
        if (isFirstLoad || hasMoreData) {
            console.log('会议记录数据有变化，动态更新视图');
            
            // 获取新增的记录
            let newRecords = [];
            if (isFirstLoad) {
                // 首次加载，所有记录都是新的
                newRecords = data;
            } else {
                // 只获取新增的记录
                const prevLength = prevMeetingRecords.value.length;
                newRecords = data.slice(prevLength);
                console.log(`发现${newRecords.length}条新记录，增量更新`);
            }
            
            // 保存当前完整数据用于下次比较
            prevMeetingRecords.value = JSON.parse(JSON.stringify(data));
            
            // 准备新增数据
            const newFormattedRecords = newRecords.map(item => ({
                ...item,
                rawContent: formattedContent(item.text, MAIN_SYMBLE, HARD_SYMBLE)
            }));
            
            // 动态添加新记录
            if (newFormattedRecords.length > 0) {
                let currentIndex = 0;
                
                // 使用函数递归添加，比setInterval更稳定
                const addRecordWithDelay = () => {
                    if (currentIndex < newFormattedRecords.length) {
                        // 添加第一条记录前就关闭loading
                        if (currentIndex === 0 && hasActualData) {
                            recordLoading.value = false;
                            console.log('开始添加记录，关闭标签loading');
                        }
                        
                        oldMeeting.records.push(newFormattedRecords[currentIndex]);
                        currentIndex++;
                        
                        // 最后一条记录添加完成后只滚动到底部和关闭局部loading
                        if (currentIndex === newFormattedRecords.length) {
                            nextTick(() => {
                                scrollToBottom();
                                // 只有在有实际数据时才关闭局部loading
                                if (hasActualData) {
                                    partialLoading.value = false; // 完成局部加载
                                    console.log('所有记录添加完成，关闭局部loading');
                                }
                            });
                            return; // 全部添加完成
                        }
                        
                        // 延迟添加下一条
                        setTimeout(addRecordWithDelay, 50);
                    }
                };
                
                // 开始添加
                addRecordWithDelay();
            } else {
                // 没有新数据时只有在获取到了实际数据时才关闭loading
                if (hasActualData) {
                    partialLoading.value = false;
                    recordLoading.value = false;
                    console.log('获取到有效会议记录数据，关闭该标签loading');
                }
            }
        } else if (prevMeetingRecords.value && !deepEqual(data, prevMeetingRecords.value)) {
            // 数据量没增加但内容有变化，检查并更新已有记录
            console.log('会议记录内容有变化，更新现有记录');
            
            // 更新现有记录的内容
            data.forEach((item, index) => {
                if (index < oldMeeting.records.length) {
                    // 只更新内容有变化的记录
                    if (!deepEqual(item, prevMeetingRecords.value[index])) {
                        oldMeeting.records[index] = {
                            ...item,
                            rawContent: formattedContent(item.text, MAIN_SYMBLE, HARD_SYMBLE)
                        };
                    }
                }
            });
            
            // 更新缓存数据
            prevMeetingRecords.value = JSON.parse(JSON.stringify(data));
            
            // 只有在有实际数据时才关闭loading
            if (hasActualData) {
                partialLoading.value = false;
                recordLoading.value = false;
                console.log('已有有效会议记录数据，关闭该标签loading');
            }
        } else {
            console.log('会议记录数据无变化，保持原样');
            
            // 只有在有实际数据时才关闭loading
            if (hasActualData) {
                partialLoading.value = false; // 数据无变化也需关闭loading
                recordLoading.value = false;
                console.log('已有有效会议记录数据，关闭该标签loading');
            }
        }
        
        return data;
    } catch (error) {
        console.error('获取会议记录失败:', error);
        // 出错时不要关闭loading，保持轮询时的loading状态
        // 如果有数据已加载，仍然保持显示
        if (oldMeeting.records && oldMeeting.records.length > 0) {
            partialLoading.value = false;
            recordLoading.value = false;
            console.log('出错但已有有效会议记录数据，关闭该标签loading');
        }
        return null;
    }
};

// 添加平滑文本记录的获取函数
const get_smooth_text_record = async () => {
    try {
        // 只有在显式调用时才设置局部loading，轮询时不重复设置
        if (!partialLoading.value) {
            partialLoading.value = true; // 开始局部加载
        }
        
        const response = await fetch(`${BASE_URL}/smoothtext/${router.currentRoute.value.params.id}`);
        const data = await response.json();
        
        // 检查是否有实际数据
        const hasActualData = Array.isArray(data) && data.length > 0;
        console.log(`获取平滑文本: ${hasActualData ? '有数据' : '无数据'}, 数据长度: ${Array.isArray(data) ? data.length : 0}`);
        
        // 如果是首次加载或数据总条数增加，则使用增量加载
        const isFirstLoad = !prevSmoothTextRecords.value;
        const hasMoreData = prevSmoothTextRecords.value && Array.isArray(data) && 
            data.length > prevSmoothTextRecords.value.length;
        
        if (isFirstLoad) {
            console.log('平滑文本首次加载，初始化数据');
            
            // 保存当前完整数据用于下次比较
            prevSmoothTextRecords.value = Array.isArray(data) ? JSON.parse(JSON.stringify(data)) : [];
            
            // 首次加载需要清空数据
            oldSmoothText.records = [];
            
            if (Array.isArray(data) && data.length > 0) {
                // 准备完整数据
                const fullRecords = data.map(item => ({
                    ...item,
                    rawContent: formattedContent(item.text, MAIN_SYMBLE, HARD_SYMBLE)
                }));
                
                // 动态添加所有记录
                let currentIndex = 0;
                
                // 使用函数递归添加，比setInterval更稳定
                const addRecordWithDelay = () => {
                    if (currentIndex < fullRecords.length) {
                        // 添加第一条记录前就关闭loading
                        if (currentIndex === 0 && hasActualData) {
                            smoothLoading.value = false;
                            console.log('开始添加平滑记录(首次加载)，关闭标签loading');
                        }
                        
                        oldSmoothText.records.push(fullRecords[currentIndex]);
                        currentIndex++;
                        
                        // 最后一条记录添加完成后滚动到底部
                        if (currentIndex === fullRecords.length) {
                            nextTick(() => {
                                scrollToBottom();
                                // 只有在有实际数据时才关闭局部loading
                                if (hasActualData) {
                                    partialLoading.value = false; // 完成局部加载
                                    console.log('所有平滑记录添加完成(首次加载)，关闭局部loading');
                                }
                            });
                            return; // 全部添加完成
                        }
                        
                        // 延迟添加下一条
                        setTimeout(addRecordWithDelay, 50);
                    }
                };
                
                // 开始添加
                addRecordWithDelay();
            } else {
                // 如果平滑数据为空，使用原始数据保证显示不为空
                console.log('平滑文本数据为空，使用原始记录数据');
                if (oldMeeting.records.length > 0) {
                    const fullRecords = oldMeeting.records.map(item => ({
                        ...item,
                        rawContent: formattedContent(item.text, MAIN_SYMBLE, HARD_SYMBLE)
                    }));
                    
                    // 动态添加记录
                    let currentIndex = 0;
                    
                    // 使用函数递归添加
                    const addRecordWithDelay = () => {
                        if (currentIndex < fullRecords.length) {
                            // 添加第一条记录前就关闭loading
                            if (currentIndex === 0 && fullRecords.length > 0) {
                                smoothLoading.value = false;
                                console.log('使用原始记录替代平滑记录，关闭标签loading');
                            }
                            
                            oldSmoothText.records.push(fullRecords[currentIndex]);
                            currentIndex++;
                            
                            // 最后一条记录添加完成后关闭局部loading
                            if (currentIndex === fullRecords.length) {
                                // 这里使用的是原始记录，如果有数据则关闭局部loading
                                if (fullRecords.length > 0) {
                                    partialLoading.value = false; // 完成局部加载
                                    console.log('使用原始记录替代平滑记录完成，关闭局部loading');
                                }
                                return; // 全部添加完成
                            }
                            
                            // 延迟添加下一条
                            setTimeout(addRecordWithDelay, 50);
                        }
                    };
                    
                    // 开始添加
                    addRecordWithDelay();
                } else {
                    // 没有数据时保持loading状态
                    // 不关闭loading
                }
            }
        } else if (hasMoreData) {
            // 只在有新数据时进行增量更新
            console.log('平滑文本有新数据，进行增量更新');
            
            // 只获取新增的记录
            const prevLength = prevSmoothTextRecords.value.length;
            const newRecords = data.slice(prevLength);
            console.log(`发现${newRecords.length}条新平滑记录，增量更新`);
            
            // 更新缓存数据
            prevSmoothTextRecords.value = JSON.parse(JSON.stringify(data));
            
            // 准备新增数据
            const newFormattedRecords = newRecords.map(item => ({
                ...item,
                rawContent: formattedContent(item.text, MAIN_SYMBLE, HARD_SYMBLE)
            }));
            
            // 动态添加新记录
            if (newFormattedRecords.length > 0) {
                let currentIndex = 0;
                
                // 使用函数递归添加，比setInterval更稳定
                const addRecordWithDelay = () => {
                    if (currentIndex < newFormattedRecords.length) {
                        // 添加第一条记录前就关闭loading
                        if (currentIndex === 0 && hasActualData) {
                            smoothLoading.value = false;
                            console.log('开始添加平滑记录，关闭标签loading');
                        }
                        
                        oldSmoothText.records.push(newFormattedRecords[currentIndex]);
                        currentIndex++;
                        
                        // 最后一条记录添加完成后滚动到底部和关闭局部loading
                        if (currentIndex === newFormattedRecords.length) {
                            nextTick(() => {
                                scrollToBottom();
                                // 只有在有实际数据时才关闭局部loading
                                if (hasActualData) {
                                    partialLoading.value = false; // 完成局部加载
                                    console.log('所有平滑记录添加完成，关闭局部loading');
                                }
                            });
                            return; // 全部添加完成
                        }
                        
                        // 延迟添加下一条
                        setTimeout(addRecordWithDelay, 50);
                    }
                };
                
                // 开始添加
                addRecordWithDelay();
            } else {
                // 没有新数据时只有在获取到了实际数据时才关闭loading
                if (hasActualData) {
                    partialLoading.value = false;
                    smoothLoading.value = false;
                }
            }
        } else if (prevSmoothTextRecords.value && Array.isArray(data) && !deepEqual(data, prevSmoothTextRecords.value)) {
            // 数据量没增加但内容有变化，检查并更新已有记录
            console.log('平滑文本内容有变化，更新现有记录');
            
            // 更新现有记录的内容
            data.forEach((item, index) => {
                if (index < oldSmoothText.records.length) {
                    // 只更新内容有变化的记录
                    if (!deepEqual(item, prevSmoothTextRecords.value[index])) {
                        oldSmoothText.records[index] = {
                            ...item,
                            rawContent: formattedContent(item.text, MAIN_SYMBLE, HARD_SYMBLE)
                        };
                    }
                }
            });
            
            // 更新缓存数据
            prevSmoothTextRecords.value = JSON.parse(JSON.stringify(data));
            
            // 只有在有实际数据时才关闭loading
            if (hasActualData) {
                partialLoading.value = false;
                smoothLoading.value = false;
            }
        } else {
            console.log('平滑文本数据无变化，保持原样');
            
            // 只有在有实际数据时才关闭loading
            if (hasActualData) {
                partialLoading.value = false; // 数据无变化时关闭loading
                smoothLoading.value = false;
            }
        }
        
        return data;
    } catch (error) {
        console.error('获取平滑文本失败:', error);
        
        // 捕获错误时，检查是否需要使用原始记录数据
        if (oldSmoothText.records.length === 0 && oldMeeting.records.length > 0) {
            console.log('平滑文本获取失败，使用原始记录数据');
            const fullRecords = oldMeeting.records.map(item => ({
                ...item,
                rawContent: formattedContent(item.text, MAIN_SYMBLE, HARD_SYMBLE)
            }));
            
            // 动态添加记录
            let currentIndex = 0;
            
            // 使用函数递归添加
            const addRecordWithDelay = () => {
                if (currentIndex < fullRecords.length) {
                    // 添加第一条记录前就关闭loading
                    if (currentIndex === 0 && fullRecords.length > 0) {
                        smoothLoading.value = false;
                        console.log('使用原始记录替代平滑记录，关闭标签loading');
                    }
                    
                    oldSmoothText.records.push(fullRecords[currentIndex]);
                    currentIndex++;
                    
                    // 最后一条记录添加完成后关闭局部loading
                    if (currentIndex === fullRecords.length) {
                        // 这里使用的是原始记录，如果有数据则关闭局部loading
                        if (fullRecords.length > 0) {
                            partialLoading.value = false; // 完成局部加载
                            console.log('使用原始记录替代平滑记录完成，关闭局部loading');
                        }
                        return; // 全部添加完成
                    }
                    
                    // 延迟添加下一条
                    setTimeout(addRecordWithDelay, 50);
                }
            };
            
            // 开始添加
            addRecordWithDelay();
        } else if (oldSmoothText.records.length > 0) {
            // 如果已经有平滑文本数据，则关闭loading
            partialLoading.value = false;
            smoothLoading.value = false;
        }
        // 否则保持loading状态
        return null;
    }
};

// Modify the handleEdit function to handle both types
const handleEdit = () => {
    Object.keys(oldMeetingSummary).forEach(key => {
        editMeetingSummary[key] = oldMeetingSummary[key]
    })
    meetingRecord.value = currentMeetingData.value.records.map(item => ({
        id: item.id,
        speaker: item.speaker,
        speaker_id: item.speaker_id,
        time: item.time,
        full_time: item.time.split(":").length == 2 ? '00:' + item.time : item.time,
        is_match: item.is_match,
        is_delete: false,
        total_start: item.total_start,
        total_end: item.total_end,
        text: formattedContent(item.text, MAIN_SYMBLE, HARD_SYMBLE)
    }));
    isEditing.value = true
    nextTick(() => {
        subscribeSplitEvent()
    })
}

// Modify the saveMeetingRecord function to handle both types
const saveMeetingRecord = () => {
    const domList = recordContent.value?.querySelectorAll('.editing-content')
    const newRecords = meetingRecord.value.map((record, index) => {
        const newRecord = {}
        Object.keys(record).forEach(key => {
            if (key == 'text') {
                newRecord[key] = filteredContent(domList[index].innerHTML)
            } else {
                newRecord[key] = record[key]
            }
        });
        newRecord.time = newRecord.full_time.substring(0, 1) == '00' ? newRecord.full_time.substring(3) : newRecord.full_time
        newRecord.index = record.id
        newRecord.merge_speaker_id = []
        return newRecord
    })

    const endpoint = activeKey.value === '原始记录' ? 'meetingrecord' : 'smoothtext';
    axios.put(`${BASE_URL}/${endpoint}/${router.currentRoute.value.params.id}`, {
        ...editMeeting,
        records: newRecords
    })
        .then(response => {
            if (response.data.code == 200) {
                isEditing.value = false
                get_meeting_state()
                if (activeKey.value === '原始记录') {
                    get_smooth_text_record()
                } else {
                    get_meeting_record()
                }
            }
        })
        .catch(error => {
            console.error('Failed:', error);
        });
}

// 保存会议总结
const saveMeetingSummary = () => {

    axios.put(`${BASE_URL}/meetingsummary/${router.currentRoute.value.params.id}`, {
        ...editMeetingSummary,
        title: editMeetingSummary.meeting_name,
        create_time: editMeetingSummary.meeting_date
    })
        .then(response => {
            if (response.data.code == 200) {
                isEditing.value = false
                get_meeting_state()
                get_meeting_summary()
            }
        })
        .catch(error => {
            console.error('Failed:', error);
        });
}


// 获取音频路径
const get_meeting_audio = async () => {
    const response = await fetch(`${BASE_URL}/meetings_path/${router.currentRoute.value.params.id}`).catch(() => { });
    if (!response) return
    const res = await response.json()
    console.log('res.audio_url', res.audio_url)
    audio_url.value = res.audio_url
};

const get_meeting_summary = async () => {
    try {
        partialLoading.value = true; // 开始局部加载
        const response = await fetch(`${BASE_URL}/show_meeting/${router.currentRoute.value.params.id}`);
        const data = await response.json();
        
        // 如果数据有变化或首次加载，才更新视图
        if (!prevMeetingSummary.value || !deepEqual(data, prevMeetingSummary.value)) {
            console.log('会议摘要数据有变化，更新视图');
            
            // 如果是首次加载，直接更新全部
            if (!prevMeetingSummary.value) {
                console.log('会议摘要首次加载，初始化数据');
                
                Object.keys(data).forEach(key => {
                    if (key == 'meeting_date') {
                        oldMeetingSummary[key] = data[key]?.replace('T', ' ').substring(0, 19);
                    } else {
                        oldMeetingSummary[key] = data[key];
                    }
                });
            } else {
                // 否则比较字段变化，只更新有变化的字段
                console.log('会议摘要部分字段变化，增量更新');
                
                Object.keys(data).forEach(key => {
                    // 检查字段是否发生变化
                    if (!deepEqual(data[key], prevMeetingSummary.value[key])) {
                        console.log(`会议摘要字段 ${key} 发生变化，更新`);
                        
                        if (key == 'meeting_date') {
                            oldMeetingSummary[key] = data[key]?.replace('T', ' ').substring(0, 19);
                        } else {
                            oldMeetingSummary[key] = data[key];
                        }
                    }
                });
            }
            
            // 更新缓存数据
            prevMeetingSummary.value = JSON.parse(JSON.stringify(data));
        } else {
            console.log('会议摘要数据无变化，保持原样');
        }
        
        partialLoading.value = false; // 完成局部加载
        summaryLoading.value = false;
        return data;
    } catch (error) {
        console.error('获取会议摘要失败:', error);
        partialLoading.value = false; // 出错时关闭loading
        if (Object.keys(oldMeetingSummary).length > 0) {
            summaryLoading.value = false;
        }
        return null;
    }
};

// 原始记录
const oldMeeting = reactive({
    title: '',
    create_time: '',
    speaker_list: '',
    records: []
});

// 监听原始记录数据变化，自动关闭对应loading
watch(
    () => oldMeeting.records.length,
    (len) => {
        if (len > 0) recordLoading.value = false
    }
)
// 原始记录
const editMeeting = reactive({
    title: '',
    create_time: '',
    speaker_list: [],
    records: [],
    active_id: myPermission.value.id
});
// 原始记录
const meetingRecord = ref([]);

// 是否可以编辑 是否可以一键修正
// 会议纪要状态是已生成(audio_summit_status == 2) 可以编辑
const disabledEdit = ref(false);

// 获取原始记录状态
const get_meeting_state = async () => {
    try {
        let id = router.currentRoute.value.params.id;
        const response = await fetch(`${BASE_URL}/meeting/${id}`);
        const data = await response.json();
        
        // 如果数据有变化或首次加载，才更新视图
        if (!prevMeetingState.value || !deepEqual(data, prevMeetingState.value)) {
            console.log('会议状态数据有变化，更新视图');
            console.log(`状态变化: audio_record_status=${data.audio_record_status}, meeting_status=${data.meeting_status}, audio_summit_status=${data.audio_summit_status}`);
            
            prevMeetingState.value = JSON.parse(JSON.stringify(data)); // 深拷贝保存当前数据
            
            disabledEdit.value = data.audio_summit_status != 2;
            oldMeeting.title = data.title;
            oldMeeting.create_time = data.create_time.replace('T', ' ').substring(0, 19);
            oldMeeting.speaker_list = data.speaker;

            editMeeting.title = data.title;
            editMeeting.create_time = data.create_time.replace('T', ' ').substring(0, 19);
            editMeeting.speaker_list = data.speaker.length ? data.speaker.split(',') : [];
            
            // 根据状态设置底部loading的显示
            // 如果原始记录或语义顺滑状态未完成（不等于2），且已有数据显示，则显示底部loading
            const hasOriginalData = oldMeeting.records && oldMeeting.records.length > 0;
            const hasSmoothData = oldSmoothText.records && oldSmoothText.records.length > 0;
            
            if ((data.audio_record_status !== 2 && hasOriginalData) || 
                (data.meeting_status !== 2 && hasSmoothData)) {
                bottomLoading.value = true;
                console.log('会议处理中，显示底部loading');
            } else {
                bottomLoading.value = false;
                console.log('会议处理完成，隐藏底部loading');
            }
            
            // 检查并启动轮询
            checkAndStartPolling();
        } else {
            console.log('会议状态数据无变化，保持原样');
        }
        
        return data;
    } catch (error) {
        console.error('获取会议状态失败:', error);
        return null;
    }
};

// 手动添加一个轮询检查函数，在每次数据更新后调用
const checkAndStartPolling = () => {
    // 定时轮询启动条件：
    // 1. 三个状态至少有一个不为2（处理中）
    // 2. 当前没有轮询定时器在运行
    const meetingState = prevMeetingState.value;
    
    if (meetingState && 
        (meetingState.audio_record_status !== 2 || 
         meetingState.meeting_status !== 2 || 
         meetingState.audio_summit_status !== 2) && 
        !stateCheckTimer.value) {
        console.log('检测到会议处理中，手动启动轮询');
        setupStatusCheckTimer();
    }
};

// 添加清空缓存数据的函数
const clearCacheData = () => {
    console.log('清空所有缓存数据');
    // 清空会议状态缓存
    prevMeetingState.value = null;
    // 清空会议摘要缓存
    prevMeetingSummary.value = null;
    // 清空会议记录缓存
    prevMeetingRecords.value = null;
    // 清空平滑文本缓存
    prevSmoothTextRecords.value = null;
    
    // 清空显示数据
    oldMeeting.title = '';
    oldMeeting.create_time = '';
    oldMeeting.speaker_list = '';
    oldMeeting.records = [];
    
    // 清空平滑文本
    oldSmoothText.records = [];
    
    // 清空会议摘要
    Object.keys(oldMeetingSummary).forEach(key => {
        oldMeetingSummary[key] = '';
    });
    
    // 重置编辑状态
    isEditing.value = false;
    
    // 重置分割参数
    splitParams.startContent = '';
    splitParams.endContent = '';
    splitParams.recordIndex = -1;
    
    // 重置选择内容
    selectContent.value = null;
    
    // 重置音频
    audio_url.value = null;
};

// 正在播放的片段index
const isPlayingIndex = ref(0)
watch(() => isPlayingIndex.value, (index) => {
    if (splitParams.recordIndex > -1) return
    const htmlContent = recordContent.value.querySelectorAll('.record-item')
    htmlContent[index].scrollIntoView({ behavior: "smooth", block: "end" });
})
// 音频播放时间
const audioTimeChange = (audioTime) => {
    if (!isEditing.value) {
        oldMeeting.records.forEach((item, index) => {
            const secondStart = convertTimeToSeconds(item.time)
            const nextSound = oldMeeting.records[index + 1] ?? oldMeeting.records[index]
            const secondEnd = convertTimeToSeconds(nextSound.time)
            item.isplaying = audioTime >= secondStart && audioTime < secondEnd
            if (item.isplaying) isPlayingIndex.value = index
        })
    } else {
        meetingRecord.value.forEach((item, index) => {
            const secondStart = convertTimeToSeconds(item.time)
            const nextSound = meetingRecord.value[index + 1] ?? meetingRecord.value[index]
            const secondEnd = convertTimeToSeconds(nextSound.time)
            item.isplaying = audioTime >= secondStart && audioTime < secondEnd
            if (item.isplaying) isPlayingIndex.value = index
        })
    }
}

const scrollToBottom = () => {
    nextTick(() => {
        if (recordContent.value) {
            const scrollHeight = recordContent.value.scrollHeight;
            const height = recordContent.value.clientHeight;
            const maxScrollTop = scrollHeight - height;
            recordContent.value.scrollTo({
                top: maxScrollTop,
                behavior: 'smooth'
            });
            
            // 如果显示底部loading，确保它也可见
            if (bottomLoading.value) {
                console.log('显示底部loading，确保滚动到最底部');
                // 额外延迟50ms再次滚动，确保底部loading完全渲染后滚动到底部
                setTimeout(() => {
                    if (recordContent.value) {
                        const newScrollHeight = recordContent.value.scrollHeight;
                        const newHeight = recordContent.value.clientHeight;
                        const newMaxScrollTop = newScrollHeight - newHeight;
                        recordContent.value.scrollTo({
                            top: newMaxScrollTop,
                            behavior: 'smooth'
                        });
                    }
                }, 50);
            }
        }
    });
};

// 修改状态检查定时器设置函数
const setupStatusCheckTimer = () => {
    // 清除旧定时器
    if (stateCheckTimer.value) {
        clearInterval(stateCheckTimer.value);
        stateCheckTimer.value = null;
    }
    
    // 设置新定时器，每次轮询都获取三种数据
    stateCheckTimer.value = setInterval(async () => {
        console.log('执行轮询检查...');
        
        try {
            // 检查会议状态
            const data = await get_meeting_state();
            
            // 不显示全局loading，但显示局部loading，采用轻量级样式
            partialLoading.value = true;
            
            // 串行获取三种数据，以减轻服务器压力并实现增量更新
            console.log('轮询获取会议摘要...');
            await get_meeting_summary();
            
            console.log('轮询获取会议记录...');
            await get_meeting_record();
            
            console.log('轮询获取平滑文本...');
            await get_smooth_text_record();
            
            // 完成后关闭局部loading
            partialLoading.value = false;
            
            console.log('轮询数据获取完成');
            
            // 检查三个状态是否都为2，满足条件则停止轮询
            if (data) {
                console.log(`当前状态: audio_record_status=${data.audio_record_status}, meeting_status=${data.meeting_status}, audio_summit_status=${data.audio_summit_status}`);
                
                if (data.audio_record_status === 2 && data.meeting_status === 2 && data.audio_summit_status === 2) {
                    console.log('检测到三个状态都已完成 (audio_record_status=2, meeting_status=2, audio_summit_status=2)');
                    
                    // 再获取一次最终数据
                    setTimeout(async () => {
                        console.log('获取最终完整数据');
                        partialLoading.value = true;
                        
                        await get_meeting_summary();
                        await get_meeting_record();
                        await get_smooth_text_record();
                        
                        partialLoading.value = false;
                        
                        // 停止轮询
                        if (stateCheckTimer.value) {
                            clearInterval(stateCheckTimer.value);
                            stateCheckTimer.value = null;
                            console.log('数据获取完成，停止轮询');
                        }
                    }, 1000);
                } else {
                    console.log('会议处理仍在进行中，继续轮询');
                    
                    // 判断哪些状态未完成
                    if (data.audio_record_status !== 2) {
                        console.log('原始记录未完成(audio_record_status != 2)');
                    }
                    if (data.meeting_status !== 2) {
                        console.log('语义顺滑未完成(meeting_status != 2)');
                    }
                    if (data.audio_summit_status !== 2) {
                        console.log('会议总结未完成(audio_summit_status != 2)');
                    }
                }
            }
        } catch (error) {
            console.error('轮询获取数据失败:', error);
            partialLoading.value = false;
        }
    }, 8000); // 使用8秒间隔，减少请求频率
};

// 额外添加一个函数专门检查轮询是否正常工作
const ensurePollingActive = () => {
    // 如果会议正在处理中且没有轮询，则启动轮询
    const meetingState = prevMeetingState.value;
    
    if (meetingState && 
        (meetingState.audio_record_status !== 2 || 
         meetingState.meeting_status !== 2 || 
         meetingState.audio_summit_status !== 2) && 
        !stateCheckTimer.value) {
        console.log('检测到会议处理中但轮询不存在，重新启动轮询');
        console.log(`当前状态: audio_record_status=${meetingState.audio_record_status}, meeting_status=${meetingState.meeting_status}, audio_summit_status=${meetingState.audio_summit_status}`);
        setupStatusCheckTimer();
    }
};

// 修改onActivated钩子，使用优化后的数据加载逻辑
onActivated(() => {
    console.log("MettingEdit activated");
    console.log("当前完整URL:", window.location.href);
    console.log("当前哈希值:", window.location.hash);
    console.log("当前查询参数:", window.location.search);
    console.log("当前活动标签页(更新前):", activeKey.value);
    
    // 清空缓存数据，防止显示上一个会议的数据
    clearCacheData();
    
    // 激活时重置各标签的加载状态
    recordLoading.value = true;
    smoothLoading.value = true;
    summaryLoading.value = true;
    
    // 重置音频播放器
    if (audioRef.value) {
        audioRef.value.setPlayTime(0);
    }
    
    // 解析URL中的tab参数
    try {
        // 获取完整URL
        const fullUrl = window.location.href;
        // 获取URL中的hash部分
        const hashPart = window.location.hash;
        console.log("完整URL:", fullUrl);
        console.log("完整hash:", hashPart);
        
        // 尝试多种方式解析tab参数
        let tabValue = null;
        
        // 方式1: 直接从hash部分提取
        if (hashPart.includes('?tab=')) {
            tabValue = hashPart.split('?tab=')[1].split('&')[0];
            console.log("方式1提取的tab值:", tabValue);
        } 
        // 方式2: 直接从URL的查询部分提取
        else if (fullUrl.includes('tab=')) {
            tabValue = fullUrl.split('tab=')[1].split('&')[0];
            console.log("方式2提取的tab值:", tabValue);
        }
        // 方式3: 使用正则表达式提取
        else {
            const matchResult = fullUrl.match(/[?&]tab=([^&]*)/);
            if (matchResult && matchResult.length > 1) {
                tabValue = matchResult[1];
                console.log("方式3提取的tab值:", tabValue);
            }
        }
        
        if (tabValue) {
            // 解码URL中的中文
            const decodedTabValue = decodeURIComponent(tabValue);
            console.log("解码后的tab值:", decodedTabValue);
            
            // 检查是否是有效的标签页
            if (['原始记录', '语义顺滑', '会议纪要'].includes(decodedTabValue)) {
                console.log("设置标签页为:", decodedTabValue);
                
                // 先保存当前值
                const oldValue = activeKey.value;
                // 设置新值
                activeKey.value = decodedTabValue;
                
                console.log("标签页从", oldValue, "变为", activeKey.value);
            } else {
                console.log("无效的标签页参数，使用默认值");
                activeKey.value = '语义顺滑';
            }
        } else {
            console.log("未找到tab参数，使用默认值");
            activeKey.value = '语义顺滑';
        }
    } catch (error) {
        console.error("解析URL参数出错:", error);
        activeKey.value = '语义顺滑';
    }
    
    // 尝试强制更新视图
    nextTick(() => {
        console.log("nextTick后的activeKey值:", activeKey.value);
    });
    
    isEditing.value = false;
    
    // 清除旧的定时器
    if (checkStatusTimer.value) {
        clearInterval(checkStatusTimer.value);
        checkStatusTimer.value = null;
    }
    
    if (stateCheckTimer.value) {
        clearInterval(stateCheckTimer.value);
        stateCheckTimer.value = null;
    }
    
    // 首次激活时重置缓存数据
    prevMeetingState.value = null;
    prevMeetingSummary.value = null;
    prevMeetingRecords.value = null;
    prevSmoothTextRecords.value = null;
    
    // 串行加载数据，确保加载稳定
    const loadData = async () => {
        try {
            console.log("开始加载数据");
            
            // 先串行加载关键数据
            const userResponse = await fetch(`${BASE_URL}/user?active_id=${myPermission.value.id}`);
            const userData = await userResponse.json();
            
            const users = Array.from(new Set(userData.items.map(item => item.name)));
            state.data = users.map(user => ({
                label: user,
                value: user,
            }));
            
            // 获取核心数据
            await get_meeting_state(); // 获取会议状态
            
            // 不在这里关闭全局loading，等待获取到实际记录数据后再关闭
            // loading.value = false;
            
            // 显示局部loading，并异步加载其他数据
            partialLoading.value = true;
            
            // 首先加载会议记录数据，这是必需的
            await get_meeting_record(); // 获取会议记录
            
            // 确保有记录可显示
            if (!oldMeeting.records || oldMeeting.records.length === 0) {
                console.error('未获取到记录数据，重试');
                await get_meeting_record(); // 再次尝试获取记录
            }
            
            // 并行获取其他非关键数据
            await Promise.all([
                get_meeting_summary(),
                get_smooth_text_record(),
                get_meeting_audio()
            ]);
            
            // 确保局部loading关闭
            partialLoading.value = false;
            
            console.log("所有数据加载完成");
            
            // 检查会议处理状态，决定是否启动轮询
            const meetingState = prevMeetingState.value;
            if (meetingState && 
                (meetingState.audio_record_status !== 2 || 
                 meetingState.meeting_status !== 2 || 
                 meetingState.audio_summit_status !== 2)) {
                console.log('会议处理中，启动轮询');
                setupStatusCheckTimer();
                
                // 每15秒检查一次轮询是否正常工作
                const pollingCheckInterval = setInterval(() => {
                    ensurePollingActive();
                }, 15000);
                
                // 当组件卸载时清理这个检查定时器
                onUnmounted(() => {
                    clearInterval(pollingCheckInterval);
                });
            }
        } catch (error) {
            console.error("数据加载失败:", error);
            partialLoading.value = false; // 关闭局部loading
            message.error("数据加载失败，请刷新页面重试");
        }
    };
    
    // 启动数据加载
    loadData();
});

// 添加返回功能
const goBack = () => {
    router.push('/meetings')
}

// 添加handleTabChange函数
const handleTabChange = (value) => {
    isEditing.value = false;
    // 更新URL，保持当前路由参数
    const currentPath = router.currentRoute.value.path;
    const id = router.currentRoute.value.params.id;
    const newPath = `/meetingedit/${id}?tab=${encodeURIComponent(value)}`;
    
    // 使用replace而不是push，避免在历史记录中创建过多条目
    router.replace(newPath);
    console.log('标签切换，更新URL为:', newPath);
}
</script>

<style scoped lang="less">
.page-container {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #f5f7fa;
    padding: 24px;
    padding-bottom: 100px; /* 为固定在底部的音频播放器留出空间 */
    display: flex;
    flex-direction: column;
}

.back-button-area {
    margin-bottom: 16px;
}

.tab-loading {
    position: relative;
    width: 100%;
    height: 300px;
    min-height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    .tab-loading-text {
        margin-top: 16px;
        color: #333;
        font-size: 16px;
    }
}

.content-area {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative; /* 确保可以相对于此定位音频播放器 */
}


.content-fade-in {
    animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.controls-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e2e8f0;
    
    :deep(.ant-segmented) {
        background-color: #f1f5f9;
        border-radius: 8px;
        
        .ant-segmented-item-selected {
            background-color: #fff;
            color: #3b82f6;
            font-weight: 600;
        }
    }
    
    .action-buttons {
        display: flex;
        gap: 12px;
        
        .ant-btn {
            display: inline-flex;
            align-items: center;
            
            .anticon {
                margin-right: 8px;
            }
        }
    }
}

.main-content-area {
    flex: 1;
    overflow: hidden;
}

.content-box {
    position: relative;
    height: 100%;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    padding: 24px;
    overflow: auto;
}

.info-section {
    margin-bottom: 24px;
}

.record-block {
    display: flex;
    align-items: center;
    min-height: 40px;
    border-bottom: 1px dashed #e2e8f0;
    margin-bottom: 12px;
    padding-bottom: 8px;
    
    .block-name {
        width: 100px;
        font-weight: 600;
        color: #1e293b;
    }
    
    .block-value {
        flex: 1;
        padding: 0 12px;
        color: #334155;
    }
    
    &.is-vertical {
        display: block;
        
        .block-name {
            width: auto;
            margin-bottom: 8px;
        }
        
        .block-value {
            padding: 16px;
            background-color: #f8fafc;
            border-radius: 8px;
            line-height: 1.5;
        }
    }
    
    .title-input {
        flex: 1;
    }
}

.content-section {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.content-label {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
    margin: 0 0 16px 0;
    padding-left: 12px;
    position: relative;
    line-height: 1.5;
    
    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background-color: #3b82f6;
        border-radius: 2px;
    }
}

.mt-record-content {
    flex: 1;
    overflow-y: auto;
    background-color: #fbfdff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    
    .record-item {
        animation: fadeInUp 0.3s ease-out;
        padding: 8px 0;
        margin-bottom: 12px;
        border-bottom: 1px solid #f5f5f5;
        
        &.is-delete {
            display: none;
        }
    }
    
    .is-playing {
        background-color: rgba(59, 130, 246, 0.05);
        border-radius: 8px;
    }
    
    .mt-record-header {
        position: relative;
        padding: 0 10px 0 20px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 4px;
        
        &::before {
            content: '';
            position: absolute;
            left: 6px;
            top: 50%;
            margin-top: -4px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #3b82f6;
        }
    }
    
    .speaker {
        color: #0f172a;
        font-weight: 600;
        margin-right: 12px;
    }
    
    .time {
        color: #64748b;
        font-size: 13px;
    }
    
    .content {
        padding: 12px 20px;
        line-height: 1.6;
        color: #334155;
        cursor: pointer;
        
        &:hover {
            background-color: #f8fafc;
        }
    }
    
    .editing-content {
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        background-color: #fff;
        margin: 0 10px;
        
        &:focus {
            outline: none;
            border-color: #3b82f6;
        }
    }
    
    :deep(.main-highlight) {
        background-color: #3b82f6;
        color: white;
        border-radius: 3px;
        padding: 0 2px;
    }
    
    :deep(.todo-highlight) {
        background-color: #ef4444;
        color: white;
        border-radius: 3px;
        padding: 0 2px;
    }
    
    .im-btn {
        margin-right: 8px;
        height: 28px !important;
        padding: 0 8px;
        font-size: 12px;
    }
}

.audio-player-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    padding: 10px 24px;
    z-index: 100;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    border-top: 1px solid #e2e8f0;
    
    :deep(.hszd-audio) {
        padding: 16px;
        background-color: #fff;
        border-radius: 8px;
    }
}

.record-wrap, .summary-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.textarea {
    border-color: #e2e8f0;
    
    &:hover, &:focus {
        border-color: #3b82f6;
    }
}

.partial-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    
    .partial-loading-text {
        margin-top: 12px;
        color: #333;
        font-size: 14px;
    }
}

.bottom-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    padding: 10px 0;
    color: #666;
    font-size: 14px;
    border-top: 1px dashed #eee;
}

.bottom-loading-text {
    margin-left: 8px;
}
</style>
